import * as React from 'react';
import { createContext, useCallback, useMemo, useState } from 'react';

export type BlurSource = {
  mask?: string;
  paintMask?: string;
  blur?: number;
  feather?: number;
};
type Source = ({ id: string; uri: string } & BlurSource) | null;
export const LinearLightEditorContext = createContext({
  source: null as Source,
  publish: (_id: string, _uri: string, _blurSource?: BlurSource): void =>
    undefined,
  clear: (_id: string): void => undefined,
});

// One transient editing texture per canvas; it is never saved in story JSON.
export function LinearLightEditorProvider({
  children,
}: {
  readonly children: React.ReactNode;
}) {
  const [source, setSource] = useState<Source>(null);
  const publish = useCallback(
    (id: string, uri: string, blurSource?: BlurSource) =>
      setSource((current) =>
        current?.id === id &&
        current.uri === uri &&
        current.mask === blurSource?.mask &&
        current.paintMask === blurSource?.paintMask &&
        current.blur === blurSource?.blur &&
        current.feather === blurSource?.feather
          ? current
          : { id, uri, ...blurSource }
      ),
    []
  );
  const clear = useCallback(
    (id: string) =>
      setSource((current) => (current?.id === id ? null : current)),
    []
  );
  const value = useMemo(
    () => ({ source, publish, clear }),
    [source, publish, clear]
  );
  return (
    <LinearLightEditorContext.Provider value={value}>
      {children}
    </LinearLightEditorContext.Provider>
  );
}
